export default "/images/framework/Grand.0bdc4eef.svg?0bdc4eef";